import service from '../request/request'

export const signInTime = (id,time) => {
  return service.request({
    url: `/signin/time`,
    method: 'get',
    params: {
      id,
      time
    }
  })
}

export const signInUpdate = (data) => {
  return service.request({
      url: "/signin/update",    
      method: 'put',
      data
  })
}

export const signInInsert = (data) => {
  return service.request({
      url: "/signin/insert",
      method: 'post',
      data
  })
}

export const signInDelete = (id) => {
  return service.request({
      url: "/signin/delete/" + id,
      method: 'delete'
  })
}



//查看签到人员
export const queryAllByActivityId = (data) => {
  return service.request({
      url: "company/queryAllByActivityId",
      method: 'post',
      data
  })
}

//查询签到列表
export const querySignInList = (data) => {
  const {pageNum,pageSize} = data
  return service.request({
      url: '/signin/list',
      method: 'post',
      params: {
        pageNum,
        pageSize
      },
      data
  })
}

export const queryAllSignInByActivityId = (data) => {
  const {pageNum,pageSize,signinId} = data
  return service.request({
    url: `signinInfromation/listpage`,
    method: 'get',
    params: {
      pageNum,
      pageSize,
      signinId
    },
  })
}

//导出签到excel
export const excelexportSignIn = (data) => {
  return service.request({
      url: "excel/export",
      method: 'post',
      data
  })
}
//删除会议的某个嘉宾(签到)
export const deleteParticipantsSignIn = (id) => {
  return service.request({
      url: "signinInfromation/delete" + id,
      method: 'delete'
  })
}